import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    certificates:[],
  }),
  mutations: {
    SET_CERTIFICATES(state, items) {
      state.certificates = items
    }
  },
  actions: {
    async fetchCertificates({ commit }, data) {
      const res = await apiClient('certificates.get', data)
      commit('SET_CERTIFICATES', res.list)
    },
    async saveCertificate({ commit }, scheduleData) {
      const res = await apiClient('certificates.create', scheduleData)
      commit('SET_CERTIFICATES', res.list)
    },
    async updateCertificate({ commit }, scheduleData) {
      const res = await apiClient('certificates.update', scheduleData)
      commit('SET_CERTIFICATES', res.list)
    },
    async deleteCertificate({ commit }, id) {
      const res = await apiClient('certificates.delete', { id })
      commit('SET_CERTIFICATES', res.list)
    }
  }
}